import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { AppState } from 'src/config/appState';

import { ProgramEnum, ProgramWeek } from '../models/programs';
import { AdditionalProgramState } from '../models/programsGeneric';
import { getProgramState, getProgramWeeksDataByProgramId } from '../selectors/programsSelectors';
import { AdditionalProgramWeekCard } from './AdditionalProgramWeekCard';
import * as S from './styles';

interface StateProps {
    program: AdditionalProgramState;
    weeks: ProgramWeek[];
}

interface Props extends StateProps, RouteComponentProps<{}>, WithTranslation {
    programId: ProgramEnum;
    webExclusive?: boolean;
}

const AdditionalProgramWeeksListContainer: React.SFC<Props> = props => (
    <>
        <S.CardsListLinkHeading onClick={props.history.goBack}>
            {props.program.title}
        </S.CardsListLinkHeading>
        <S.CardsList>
            {props.weeks.map(week => (
                <AdditionalProgramWeekCard
                    key={week.id}
                    programId={props.programId}
                    weekId={week.id}
                    title={week.title}
                    iconUrl={week.iconUrl}
                    weekUrl={`/programs/${props.programId}/${week.id}`}
                    webExclusive={props.webExclusive}
                />
            ))}
        </S.CardsList>
    </>
);

const mapStateToProps = (state: AppState, { programId }: Props) => ({
    program: getProgramState(state, programId),
    weeks: getProgramWeeksDataByProgramId(state, programId),
});

export const AdditionalProgramWeeksList = withRouter(
    withTranslation()(connect<StateProps>(mapStateToProps)(AdditionalProgramWeeksListContainer)),
);
